module.exports = __webpack_public_path__ + "img/retrieve-icon.6b826606.svg";